module.exports = "/_next/static/images/placeholder-98e80b7d73eab50e027414974c0e8028.jpg";